import { AddChildForm } from "../components/AddChild/AddChildForm";
import { PageContainer } from "../components/PageContainer";

export const AddChild = () => {
  return (
    <PageContainer>
      <AddChildForm />
    </PageContainer>
  );
};
